export default {"src":"/_next/static/media/TEX.ab9221b0.svg","height":18,"width":18};